/* global Eht */
import { Table, Page, TableR } from '@bag'

class TableView {
  constructor(opt) {
    const def = {
      selector: null,
      defaultDisValue: '',
      paginate: new Eht.Paginate(),
      pageType: true,
      defColumnWidth: 0,
      valueCodeField: 'f_code',
      labelCodeField: 'f_name',
      multable: false,
      loadInit: true,
      selectedField: 'selected',
      treeGrid: false,
      childrenField: 'nodes',
      highest: '300',
      codeContent: Eht.DataCode,
      anchor: window,
      modal: '',
      page: 'on',
    }
    this.opt = Object.assign(def, opt)
    this.selector = $(this.opt.selector)
    if (!this.opt.paginate) this.opt.page = 'off'
    const table = (this.tableObj = new Table(this.selector, this.opt))
    this.table = table.unit
    this.selector.append(this.table)
    if (this.opt.page === 'on') {
      const page = (this.pageObj = new Page())
      this.table.after(page.unit)
      page.pageChange($.proxy(this.pageChange, this))
    }
    if (this.opt.anchor) {
      $(this.opt.anchor).resize(() => {
        this.tableObj.trimFinal()
      })
    }
    if (this.opt.modal) {
      $(this.opt.modal).on('shown.bs.modal', () => {
        this.tableObj.trimFinal()
      })
    }
  }

  pageChange(page) {
    if (this._loadData) {
      this.tableObj.loading = true
      this._loadData(page, this.loadResp)
    }
  }

  loadData(args) {
    if (this._object == null) {
      this._object = args
    }
    const table = this.tableObj
    if (args) {
      if ($.type(args) === 'object') {
        this.data = args.rows ? args.rows : []
      } else if ($.type(args) === 'array') {
        this.data = args
      } else if ($.type(args) === 'function') {
        table.loading && (table.loading = false)
        table.loading = true
        this._loadData = args
        if (this.loadResp == null) {
          this.loadResp = new Eht.Responder()
          var error = this.loadResp.error
          this.loadResp.success = (data, textStatus, jqXHR) => {
            this.loadData(data)
            this.setPageInfo(data.paginate)
            if (this._loadComplete != null) {
              this._loadComplete(data)
            }
          }
          this.loadResp.error = function (data, textStatus, jqXHR) {
            error(data, textStatus, jqXHR)
          }
        }
        if (this.opt.loadInit) {
          this._loadData(this.opt.paginate, this.loadResp)
        }
        return
      }
      if ($.type(this.data) === 'array') {
        table.checkedRow = {}
        table.data = this.data
        table.loading = false
      }
    }
  }

  setPageInfo(page) {
    if (this.opt.page === 'on') {
      if (page.totalPage && page.indexPage > page.totalPage) page.indexPage = 1
      this.pageObj.data = this.opt.paginate = Object.assign(
        new Eht.Paginate(),
        page
      )
    }
  }

  eachData(func) {
    this._eachData = func
  }

  addRow(data, treeLvl, pIndex, pClass) {}

  getSelectedData() {
    if (this.opt.multable) {
      return this.checkedRow.datas
    }
    if (this.checkedRow.data) {
      return [this.checkedRow.data]
    }
    return []
  }

  toggle(selected) {}

  transColumn(field, func) {
    this.tableObj.transColumn(field, func)
  }

  selectedRow(func) {
    this._selectedRow = func
  }

  clickRow(func) {
    this.tableObj.currentChange(func)
  }

  dblclickRow(func) {
    this._dblclickRow = func
  }

  loadComplete(func) {
    this._loadComplete = func
  }

  refresh() {
    if (this.opt.paginate != null) {
      this.opt.paginate.indexPage = 1
    }
    this.opt.loadInit = true
    this.loadData(this._object)
  }

  get checkedRow() {
    if (this.opt.multable) {
      return {
        datas: Object.values(this.tableObj.checkedRow),
      }
    }
    return this.tableObj.checkedRow
  }
}

Eht.TableViewS = TableView

export default TableView
